export default __webpack_public_path__ + "06bf81a201178decf29a3ecd09d1840f.woff";